module.exports = __webpack_public_path__ + "static/media/goledger_login.eda869ec.svg";